<template>
  <div>
    <!-- 数据表格 -->
    <el-table :data="engineList" style="width: 100%" v-loading="loading" :stripe="true">
      <el-table-column prop="brandName" label="Brand" width="150" align="center"></el-table-column>
      <el-table-column prop="modelName" label="Model Range" width="300" align="center">
        <template slot-scope="scope">
          {{ scope.row.model }} ({{ scope.row.type }})
        </template>
      </el-table-column>
      <el-table-column prop="yearFrom" label="Model Year" width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.yearFrom }} - {{ scope.row.yearTo }}
        </template>
      </el-table-column>
      <el-table-column prop="engineCode" label="Engine" width="130" align="center">
        <template slot-scope="scope">
          {{ scope.row.engineLiters }}({{ scope.row.engineCode }})
          </template>
      </el-table-column>
      <el-table-column prop="engineLiters" label="Power kW (h.p.)" width="140" align="center">
        <template slot-scope="scope">
          {{ scope.row.pw }}({{ scope.row.ph }})
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页组件 -->
    <div class="pagination-container">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pagination.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
        prev-text="Previous"
        next-text="Next">
      </el-pagination>
    </div>

    <!-- 空数据提示 -->
    <div v-if="engineList.length === 0 && !loading" class="empty-tip">
      No engine data available
    </div>
  </div>
</template>

<script>
import partsApi from '../api/partsApi'

export default {
  name: 'CarTab',
  props: {
    apcNo: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      engineList: [],
      loading: false,
      pagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  watch: {
    apcNo: {
      handler(newVal, oldVal) {
        if (newVal && newVal !== oldVal) {
          this.pagination.pageNum = 1 // 重置到第一页
          this.fetchEngineList()
        } else if (!newVal) {
          this.engineList = []
          this.pagination.total = 0
        }
      },
      immediate: true
    }
  },
  methods: {
    // 获取发动机列表数据
    async fetchEngineList() {
      if (!this.apcNo) {
        this.engineList = []
        this.pagination.total = 0
        return
      }

      this.loading = true
      try {
        const response = await partsApi.getEngineListByApc(
          this.apcNo,
          this.pagination.pageNum,
          this.pagination.pageSize
        )


        if (response.data && response.data.code === 200) {
          this.engineList = response.data.data.records || []
          this.pagination.total = response.data.data.total || 0
        } else {
          this.$message.error(response.data.msg || 'Failed to fetch engine data')
          this.engineList = []
          this.pagination.total = 0
        }
      } catch (error) {
        this.$message.error('Failed to fetch engine data, please try again later')
        this.engineList = []
        this.pagination.total = 0
      } finally {
        this.loading = false
      }
    },

    // 分页大小改变
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.pagination.pageNum = 1 // 切换页码时重置当前页
      this.fetchEngineList()
    },

    // 当前页改变
    handleCurrentChange(val) {
      this.pagination.pageNum = val
      this.fetchEngineList()
    },

    // 刷新数据
    refresh() {
      this.fetchEngineList()
    },

    // 暴露给父组件的方法
    reloadData() {
      this.fetchEngineList()
    }
  }
}
</script>

<style scoped>
.pagination-container {
  margin-top: 20px;
  text-align: center;
  padding: 20px 0;
}

.pagination-container .el-pagination {
  justify-content: center;
}

.empty-tip {
  text-align: center;
  color: #999;
  font-size: 14px;
  padding: 40px 20px;
}

.el-table {
  margin-bottom: 20px;
}

/* 表格样式优化 */
.el-table th {
  background-color: #f5f7fa;
  color: #606266;
  font-weight: 600;
}

.el-table td {
  padding: 12px 0;
}

/* 加载状态样式 */
.el-loading-mask {
  background-color: rgba(255, 255, 255, 0.8);
}

/* 空数据提示样式 */
.empty-tip {
  background: #fafbfc;
  border-radius: 8px;
  border: 1px dashed #d9d9d9;
  margin: 20px 0;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .el-table {
    font-size: 12px;
  }

  .pagination-container {
    padding: 15px 0;
  }
}
</style>
